import { useState } from 'react';
import { invokeAI } from '@/lib/aiInvoke';

interface EvaluationRequest {
  text: string;
  grade: string;
  subject: string;
  writingType: string;
  topic: string;
}

interface EvaluationResponse {
  enhancedText: string;
  feedback: string[];
  badges: string[];
}

export const useWritingEvaluation = () => {
  const [isLoading, setIsLoading] = useState(false);

  const evaluateWriting = async (request: EvaluationRequest): Promise<EvaluationResponse> => {
    setIsLoading(true);

    try {
      const { data, error } = await invokeAI<EvaluationResponse>('evaluate-writing', {
        body: request,
      });

      if (error) {
        throw new Error((error as Error).message);
      }

      return data as EvaluationResponse;
    } catch (error) {
      console.error('Writing evaluation error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    evaluateWriting,
    isLoading,
  };
};
